import Cookies from 'js-cookie'
import { AuthProvider } from 'react-admin'

import { notifications } from '@mantine/notifications'
import { API } from './../helpers/Api.helper'
import { AUTH_COOKIE, AUTH_COOKIE_OPTIONS } from './../helpers/Auth.helper'

export const authProvider: AuthProvider = {
  login: async ({ email, password }) => {
    await API.post('/api/authSessions', {
      email,
      password,
    }).then(res => {
      Cookies.set(AUTH_COOKIE, res.data.jwt, AUTH_COOKIE_OPTIONS)
    })
  },
  logout: () => {
    Cookies.remove(AUTH_COOKIE)

    return Promise.resolve()
  },
  checkError: ({ status, ...error }) => {
    if (status === 401) {
      Cookies.remove(AUTH_COOKIE)

      return Promise.reject()
    }

    if (status === 403) {
      notifications.show({
        color: 'red',
        title: 'Unkown error',
        message: `${status} — ${JSON.stringify(error)}`,
        withCloseButton: true,
        autoClose: 3600,
      })
    }

    return Promise.resolve()
  },
  checkAuth: () => {
    return Cookies.get(AUTH_COOKIE) ? Promise.resolve() : Promise.reject()
  },
  getPermissions: () => Promise.resolve(),
}
